import { Timeslot } from "../timeslots.types";

/**
 * Groups timeslots by their local date string (ISO format).
 * This allows grouping by actual dates rather than day-of-week index.
 */
export function groupTimeslotsByDay(timeSlots: Timeslot[]) {
  const grouped: Record<string, Timeslot[]> = {};

  for (const slot of timeSlots) {
    // Use localDateISO (YYYY-MM-DD format) for consistent local date grouping
    const dateKey = slot.local.start.localDateISO;

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
    }
    grouped[dateKey].push(slot);
  }

  return grouped;
}

export default groupTimeslotsByDay;

